import { useContext } from "react";
import { UserRegionContext } from "@/contexts/userRegionContextDef";

export function useUserRegion() {
  const context = useContext(UserRegionContext);
  if (!context) {
    throw new Error("useUserRegion must be used within a UserRegionProvider");
  }
  return context;
}
